// Artwork data for Georg Esco galleries
// Updated with clean press images and correct descriptions

// Portrait images
const PORTRAITS = {
  hoChiMinh: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/yygno11g_1000015141.jpg',
  ramaIX: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/yixvpqc8_1000024814.jpg',
  georgesEnesco: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/y6n70j4g_1000024817.jpg',
  michelColuche: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7oebqyx9_1000024816.jpg',
  elisabethII: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/mm8ecar5_1000014823.jpg',
  mihaiEminescu: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/l1kc79v7_1000014824.jpg',
  josephineBaker: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1qjef3pm_1000014816.jpg',
  emilCioran: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wx9ppw3g_1000014817.jpg',
  napoleonBonaparte: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/53q3glez_1000025425.jpg',
  margueriteDuras: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/o2bjuyid_1000014819.jpg',
  martinLutherKing: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1pug3g18_1000023511.jpg',
  simoneVeil: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/tigxwnio_1000014855.jpg'
};

// Press/Exhibition images - CLEAN versions
const PRESS_IMAGES = {
  agitation: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/d039ymab_1000014856.jpg',
  simoneVeil: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1keap24i_1000014855.jpg',
  emergence: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/50hyj4oh_1000014862.jpg',
  certificatPrixA: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/el6usyge_1000018335.jpg',
  galerieCausans: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/irvzx6l5_1000014860.jpg',
  galerieVisite: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/pjqk3mds_1000018332.jpg',
  remisePrixA: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0ub638qw_1000018334.jpg'
};

// Placeholder for galleries waiting for images
const PLACEHOLDER = PORTRAITS.hoChiMinh;

export const artworks = {
  portraits: {
    id: 'portraits',
    title: 'portraits',
    images: [
      {
        id: 'ho-chi-minh',
        title: {
          fr: 'Sur les traces de Hô Chi Minh',
          en: 'On the Trail of Ho Chi Minh',
          zh: '胡志明的足迹',
          ja: 'ホー・チ・ミンの足跡',
          es: 'Tras las huellas de Ho Chi Minh',
          ro: 'Pe urmele lui Ho Chi Minh',
          ru: 'По следам Хо Ши Мина',
          ar: 'على خطى هو تشي منه'
        },
        year: '2021-2025',
        technique: {
          fr: 'Huile et acrylique sur toile',
          en: 'Oil and acrylic on canvas',
          zh: '帆布上的油画和丙烯',
          ja: 'キャンバスに油彩とアクリル',
          es: 'Óleo y acrílico sobre lienzo',
          ro: 'Ulei și acrilic pe pânză',
          ar: 'زيت وأكريليك على قماش',
          ru: 'Масло и акрил на холсте'
        },
        dimensions: '142 x 120 cm',
        description: {
          fr: 'Président du Viêt Nam - Lauréat Prix A 2025',
          en: 'President of Vietnam - Prize A Winner 2025',
          zh: '越南总统 - 2025年A奖获得者',
          ja: 'ベトナム大統領 - 2025年A賞受賞者',
          es: 'Presidente de Vietnam - Ganador del Premio A 2025',
          ro: 'Președinte al Vietnamului - Laureat Premiul A 2025',
          ar: 'رئيس فيتنام - الفائز بجائزة A 2025',
          ru: 'Президент Вьетнама - Лауреат премии A 2025'
        },
        image: PORTRAITS.hoChiMinh,
        featured: true
      },
      {
        id: 'rama-ix',
        title: {
          fr: 'Rama IX (Bhumibol Adulyadej)',
          en: 'Rama IX (Bhumibol Adulyadej)',
          zh: '拉玛九世 (普密蓬·阿杜德)',
          ja: 'ラーマ9世 (プーミポン・アドゥンヤデート)',
          es: 'Rama IX (Bhumibol Adulyadej)',
          ro: 'Rama al IX-lea (Bhumibol Adulyadej)',
          ru: 'Рама IX (Пхумипон Адульядет)',
          ar: 'راما التاسع (بوميبول أدولياديج)'
        },
        year: '2021 - 20 avril 2026',
        technique: {
          fr: 'Huile et acrylique sur toile',
          en: 'Oil and acrylic on canvas',
          zh: '帆布上的油画和丙烯',
          ja: 'キャンバスに油彩とアクリル',
          es: 'Óleo y acrílico sobre lienzo',
          ro: 'Ulei și acrilic pe pânză',
          ar: 'زيت وأكريليك على قماش',
          ru: 'Масло и акрил на холсте'
        },
        dimensions: '126 x 96,5 cm',
        description: {
          fr: 'Roi de Thaïlande - Peinture par Georg Esco',
          en: 'King of Thailand - Painting by Georg Esco',
          zh: '泰国国王 - 乔治·埃斯科绘画',
          ja: 'タイ国王 - ゲオルク・エスコによる絵画',
          es: 'Rey de Tailandia - Pintura de Georg Esco',
          ro: 'Regele Thailandei - Pictură de Georg Esco',
          ar: 'ملك تايلاند - لوحة لجورج إسكو',
          ru: 'Король Таиланда - Картина Георга Эско'
        },
        credit: {
          fr: 'Œuvre originale unique - Reproduction interdite',
          en: 'Unique original artwork - Reproduction prohibited',
          zh: '独特的原创艺术品 - 禁止复制',
          ja: 'ユニークなオリジナル作品 - 複製禁止',
          es: 'Obra original única - Reproducción prohibida',
          ro: 'Operă originală unică - Reproducere interzisă',
          ar: 'عمل فني أصلي فريد - يُمنع النسخ',
          ru: 'Уникальная оригинальная работа - Воспроизведение запрещено'
        },
        image: PORTRAITS.ramaIX,
        featured: true
      },
      {
        id: 'simone-veil',
        title: {
          fr: 'Simone Veil, un autre regard',
          en: 'Simone Veil, Another Perspective',
          zh: '西蒙娜·韦伊，另一种视角',
          ja: 'シモーヌ・ヴェイユ、別の視点',
          es: 'Simone Veil, otra mirada',
          ro: 'Simone Veil, o altă privire',
          ru: 'Симона Вейль, другой взгляд',
        
          ar: 'سيمون فايل، نظرة أخرى'},
        year: '2022',
        technique: {
          fr: 'Huile et acrylique sur toile',
          en: 'Oil and acrylic on canvas',
          zh: '帆布上的油画和丙烯',
          ja: 'キャンバスに油彩とアクリル',
          es: 'Óleo y acrílico sobre lienzo',
          ro: 'Ulei și acrilic pe pânză',
          ar: 'زيت وأكريليك على قماش',
          ru: 'Масло и акрил на холсте'
        },
        dimensions: '122 x 114 cm',
        description: {
          fr: 'Hommage à Simone Veil - Salon d\'Automne 2022',
          en: 'Tribute to Simone Veil - Autumn Salon 2022',
          zh: '向西蒙娜·韦伊致敬 - 2022年秋季沙龙',
          ja: 'シモーヌ・ヴェイユへのオマージュ - 2022年秋のサロン',
          es: 'Homenaje a Simone Veil - Salón de Otoño 2022',
          ro: 'Omagiu adus Simonei Veil - Salonul de Toamnă 2022',
          ar: 'تحية لسيمون فيل - صالون الخريف 2022',
          ru: 'Дань уважения Симоне Вейль - Осенний салон 2022'
        },
        image: PORTRAITS.simoneVeil
      },
      {
        id: 'georges-enesco',
        title: {
          fr: 'Georges Enesco',
          en: 'George Enescu',
          zh: '乔治·埃内斯库',
          ja: 'ジョルジュ・エネスク',
          es: 'Georges Enesco',
          ro: 'George Enescu',
          ru: 'Жорж Энеску',
        
          ar: 'جورج إنيسكو'},
        year: '2021 - 19 mai 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '120 x 101 cm',
        description: 'Compositeur et violoniste roumain',
        image: PORTRAITS.georgesEnesco
      },
      {
        id: 'michel-coluche',
        title: {
          fr: 'Michel Coluche',
          en: 'Michel Coluche',
          zh: '米歇尔·科吕什',
          ja: 'ミシェル・コリューシュ',
          es: 'Michel Coluche',
          ro: 'Michel Coluche',
          ru: 'Мишель Колюш',
        
          ar: 'ميشيل كولوش'},
        year: '2021 - 25 Mars 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '116 × 100 cm',
        description: 'Humoriste et fondateur des Restos du Cœur',
        image: PORTRAITS.michelColuche
      },
      {
        id: 'elisabeth-ii',
        title: {
          fr: 'Élisabeth II',
          en: 'Elizabeth II',
          zh: '伊丽莎白二世',
          ja: 'エリザベス2世',
          es: 'Isabel II',
          ro: 'Elisabeta a II-a',
          ru: 'Елизавета II',
        
          ar: 'إليزابيث الثانية'},
        year: '2021-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '122 x 102 cm',
        description: 'Reine du Royaume-Uni',
        image: PORTRAITS.elisabethII
      },
      {
        id: 'mihai-eminescu',
        title: {
          fr: 'Mihai Eminescu',
          en: 'Mihai Eminescu',
          zh: '米哈伊·爱明内斯库',
          ja: 'ミハイ・エミネスク',
          es: 'Mihai Eminescu',
          ro: 'Mihai Eminescu',
          ru: 'Михай Эминеску',
        
          ar: 'ميهاي إمينيسكو'},
        year: '2022-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '117 x 100 cm',
        description: 'Poète national roumain',
        image: PORTRAITS.mihaiEminescu
      },
      {
        id: 'josephine-baker',
        title: {
          fr: 'Joséphine Baker',
          en: 'Josephine Baker',
          zh: '约瑟芬·贝克',
          ja: 'ジョセフィン・ベーカー',
          es: 'Josefina Baker',
          ro: 'Josephine Baker',
          ru: 'Жозефина Бейкер',
        
          ar: 'جوزفين بيكر'},
        year: '2021-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '120 x 100 cm',
        description: 'Artiste et résistante franco-américaine',
        image: PORTRAITS.josephineBaker
      },
      {
        id: 'emil-cioran',
        title: {
          fr: 'Emil Cioran',
          en: 'Emil Cioran',
          zh: '埃米尔·齐奥朗',
          ja: 'エミール・シオラン',
          es: 'Emil Cioran',
          ro: 'Emil Cioran',
          ru: 'Эмиль Чоран',
        
          ar: 'إميل سيوران'},
        year: '2022-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '122 x 97 cm',
        description: 'Philosophe et écrivain roumain',
        image: PORTRAITS.emilCioran
      },
      {
        id: 'napoleon-bonaparte',
        title: {
          fr: 'Napoléon Bonaparte',
          en: 'Napoleon Bonaparte',
          zh: '拿破仑·波拿巴',
          ja: 'ナポレオン・ボナパルト',
          es: 'Napoleón Bonaparte',
          ro: 'Napoleon Bonaparte',
          ru: 'Наполеон Бонапарт',
        
          ar: 'نابليون بونابرت'},
        year: '2021 - 8 juin 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '121 x 100 cm',
        description: 'Empereur des Français',
        image: PORTRAITS.napoleonBonaparte
      },
      {
        id: 'marguerite-duras',
        title: {
          fr: 'Marguerite Duras',
          en: 'Marguerite Duras',
          zh: '玛格丽特·杜拉斯',
          ja: 'マルグリット・デュラス',
          es: 'Marguerite Duras',
          ro: 'Marguerite Duras',
          ru: 'Маргерит Дюрас',
        
          ar: 'مارغريت دوراس'},
        year: '2022-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '120 x 100 cm',
        description: 'Écrivaine et cinéaste française',
        image: PORTRAITS.margueriteDuras
      },
      {
        id: 'martin-luther-king',
        title: {
          fr: 'Martin Luther King',
          en: 'Martin Luther King',
          zh: '马丁·路德·金',
          ja: 'マーティン・ルーサー・キング',
          es: 'Martin Luther King',
          ro: 'Martin Luther King',
          ru: 'Мартин Лютер Кинг',
        
          ar: 'مارتن لوثر كينغ'},
        year: '2021 - 20 mai 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '120 x 100 cm',
        description: 'Pasteur et militant américain',
        image: PORTRAITS.martinLutherKing
      },
      {
        id: 'charles-de-gaulle',
        title: {
          fr: 'Le Général de Gaulle',
          en: 'General de Gaulle',
          zh: '戴高乐将军',
          ja: 'ドゴール将軍',
          es: 'El General de Gaulle',
          ro: 'Generalul de Gaulle',
          ru: 'Генерал де Голль',
        
          ar: 'الجنرال ديغول'},
        year: '2021 - 4 juin 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '124 x 101 cm',
        description: 'Portrait du Général de Gaulle en uniforme militaire',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/05juuujc_1000025422.jpg'
      },
      {
        id: 'mao-zedong',
        title: {
          fr: 'Mao Zedong',
          en: 'Mao Zedong',
          zh: '毛泽东',
          ja: '毛沢東',
          es: 'Mao Zedong',
          ro: 'Mao Zedong',
          ru: 'Мао Цзэдун',
        
          ar: 'ماو تسي تونغ'},
        year: '2015-2025',
        technique: 'Huile et acrylique sur toile',
        dimensions: '142,5 x 110 cm',
        description: 'Leader de la République populaire de Chine',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2ycpvttu_1000016354.jpg'
      },
      {
        id: 'nelson-mandela',
        title: {
          fr: 'Nelson Mandela',
          en: 'Nelson Mandela',
          zh: '纳尔逊·曼德拉',
          ja: 'ネルソン・マンデラ',
          es: 'Nelson Mandela',
          ro: 'Nelson Mandela',
          ru: 'Нельсон Мандела',
        
          ar: 'نيلسون مانديلا'},
        year: '2021 - 30 mai 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '123 x 100 cm',
        description: 'Leader anti-apartheid et président d\'Afrique du Sud',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5do1ovs5_1000024412.jpg'
      },
      {
        id: 'rosa-parks',
        title: {
          fr: 'Rosa Parks',
          en: 'Rosa Parks',
          zh: 'Rosa Parks',
          ja: 'Rosa Parks',
          es: 'Rosa Parks',
          ro: 'Rosa Parks',
          ru: 'Rosa Parks',
          ar: 'Rosa Parks'
        },
        year: '2021 - 19 mai 2026',
        technique: 'Huile et acrylique sur toile',
        dimensions: '118 x 103 cm',
        description: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/74csscyo_1000024815.jpg'
      }
    ]
  },
  landscapes: {
    id: 'landscapes',
    title: 'landscapes',
    subtitle: 'Souvenirs d\'enfance',
    images: [
      {
        id: 'brancusi-house',
        title: {
          fr: 'La maison natale de Constantin Brancusi',
          en: 'Constantin Brancusi\'s Birthplace',
          zh: '康斯坦丁·布朗库西的出生地',
          ja: 'コンスタンティン・ブランクーシの生家',
          es: 'Casa natal de Constantin Brancusi',
          ro: 'Casa natală a lui Constantin Brâncuși',
          ru: 'Дом рождения Константина Бранкузи',
        
          ar: 'منزل ولادة قسطنطين برانكوزي'},
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        description: 'Hommage au grand sculpteur roumain - Hobița, Roumanie',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gjk7phm9_1000015111.jpg'
      },
      {
        id: 'paysage-automne',
        title: {
          fr: 'Maison d\'automne',
          en: 'Autumn House',
          zh: '秋天的房子',
          ja: '秋の家',
          es: 'Casa de otoño',
          ro: 'Casa de toamnă',
          ru: 'Осенний дом',
          ar: 'منزل الخريف'
        },
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3je0uex6_1000015114.jpg'
      },
      {
        id: 'paysage-rivages',
        title: {
          fr: 'Rivages d\'enfance',
          en: 'Childhood Shores',
          zh: '童年的海岸',
          ja: '子供時代の海岸',
          es: 'Costas de la infancia',
          ro: 'Maluri de copilărie',
          ru: 'Берега детства',
          ar: 'شواطئ الطفولة'
        },
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ys4um3ep_1000015113.jpg'
      },
      {
        id: 'nature-morte-fleurs',
        title: {
          fr: 'Nature morte aux fleurs',
          en: 'Still Life with Flowers',
          zh: '花卉静物',
          ja: '花の静物画',
          es: 'Naturaleza muerta con flores',
          ro: 'Natură moartă cu flori',
          ru: 'Натюрморт с цветами',
        
          ar: 'طبيعة صامتة بالزهور'},
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7ykagq8h_1000015112.jpg'
      },
      {
        id: 'paysage-village',
        title: {
          fr: 'Village au bord de l\'eau',
          en: 'Village by the Water',
          zh: '水边的村庄',
          ja: '水辺の村',
          es: 'Pueblo junto al agua',
          ro: 'Sat lângă apă',
          ru: 'Деревня у воды',
          ar: 'قرية على الماء'
        },
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3ljbbo7z_1000015110.jpg'
      },
      {
        id: 'paysage-1',
        title: {
          fr: 'Reflets de Montagne',
          en: 'Mountain Reflections',
          zh: '山的倒影',
          ja: '山の反射',
          es: 'Reflejos de montaña',
          ro: 'Reflecții de munte',
          ru: 'Горные отражения',
        
          ar: 'انعكاسات الجبل'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/zzw8djli_1000014898.jpg'
      },
      {
        id: 'paysage-2',
        title: {
          fr: 'Maison au Gazebo',
          en: 'House with Gazebo',
          zh: '带凉亭的房子',
          ja: '東屋のある家',
          es: 'Casa con cenador',
          ro: 'Casă cu foișor',
          ru: 'Дом с беседкой',
        
          ar: 'منزل مع غازيبو'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/djtozksi_1000014899.jpg'
      },
      {
        id: 'paysage-3',
        title: {
          fr: 'Vallée Dorée',
          en: 'Golden Valley',
          zh: '金色山谷',
          ja: '黄金の谷',
          es: 'Valle dorado',
          ro: 'Valea de Aur',
          ru: 'Золотая долина',
        
          ar: 'الوادي الذهبي'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/1a0d8n8k_1000014900.jpg'
      },
      {
        id: 'nature-morte-1',
        title: {
          fr: 'Bouquet Flamboyant',
          en: 'Flamboyant Bouquet',
          zh: '火红的花束',
          ja: '燃えるような花束',
          es: 'Ramo flamante',
          ro: 'Buchet flambant',
          ru: 'Пламенный букет',
        
          ar: 'باقة متوهجة'},
        year: '1998',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/7vyyv82y_1000014901.jpg'
      }
    ]
  },
  genesis: {
    id: 'genesis',
    title: 'genesis',
    images: [
      {
        id: 'genese-1',
        title: { fr: 'Genèse de la Vie I', en: 'Genesis of Life I', zh: '生命起源 I', ja: '生命の創世記 I', es: 'Génesis de la Vida I', ro: 'Geneza Vieții I', ru: 'Генезис жизни I', 
          ar: 'نشأة الحياة I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wnvvlhj4_1000014956.jpg'
      },
      {
        id: 'genese-2',
        title: { fr: 'Genèse de la Vie II', en: 'Genesis of Life II', zh: '生命起源 II', ja: '生命の創世記 II', es: 'Génesis de la Vida II', ro: 'Geneza Vieții II', ru: 'Генезис жизни II', 
          ar: 'نشأة الحياة II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '101 x 94 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/bvv4mkq9_1000014955.jpg'
      },
      {
        id: 'genese-3',
        title: { fr: 'Genèse de la Vie III', en: 'Genesis of Life III', zh: '生命起源 III', ja: '生命の創世記 III', es: 'Génesis de la Vida III', ro: 'Geneza Vieții III', ru: 'Генезис жизни III', 
          ar: 'نشأة الحياة III'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '101 x 94 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/e3w2imcq_1000014954.jpg'
      },
      {
        id: 'genese-4',
        title: { fr: 'Le Cri californien', en: 'The Californian Scream', zh: '加利福尼亚的呐喊', ja: 'カリフォルニアの叫び', es: 'El Grito californiano', ro: 'Strigătul californ', ru: 'Калифорнийский крик', 
          ar: 'الصرخة الكاليفورنية'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '80 x 210 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3d5qh259_1000014974.jpg'
      },
      {
        id: 'genese-5',
        title: { fr: 'Explosion Primordiale II', en: 'Primordial Explosion II', zh: '原始爆炸 II', ja: '原初の爆発 II', es: 'Explosión Primordial II', ro: 'Explozia Primordială II', ru: 'Первобытный взрыв II', 
          ar: 'الانفجار البدائي II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/h915edqy_1000014973.jpg'
      },
      {
        id: 'genese-6',
        title: { fr: 'Chaos Originel I', en: 'Original Chaos I', zh: '原始混沌 I', ja: '原初のカオス I', es: 'Caos Original I', ro: 'Haosul Originar I', ru: 'Изначальный хаос I', 
          ar: 'الفوضى الأصلية I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/n7uz0usl_1000014977.jpg'
      },
      {
        id: 'genese-7',
        title: { fr: 'Chaos Originel II', en: 'Original Chaos II', zh: '原始混沌 II', ja: '原初のカオス II', es: 'Caos Original II', ro: 'Haosul Originar II', ru: 'Изначальный хаос II', 
          ar: 'الفوضى الأصلية II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/q3sbpo0s_1000014976.jpg'
      },
      {
        id: 'genese-8',
        title: 'Naissance du Monde',
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '124 x 85 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/rwce6svv_1000014978.jpg'
      }
    ]
  },
  grids: {
    id: 'grids',
    title: 'grids',
    images: [
      {
        id: 'quadrillage-1',
        title: { fr: 'Quadrillage I', en: 'Grid I', zh: '网格 I', ja: 'グリッド I', es: 'Cuadrícula I', ro: 'Caroiaj I', ru: 'Решётка I', 
          ar: 'شبكة I'},
        year: '2023',
        technique: 'Peinture sur toile',
        dimensions: '121 x 102 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/n3h6ae5n_1000014960.jpg'
      },
      {
        id: 'quadrillage-2',
        title: { fr: 'Quadrillage II', en: 'Grid II', zh: '网格 II', ja: 'グリッド II', es: 'Cuadrícula II', ro: 'Caroiaj II', ru: 'Решётка II', 
          ar: 'شبكة II'},
        year: '2023',
        technique: 'Peinture sur toile',
        dimensions: '121 x 102 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/oejcvki3_1000014959.jpg'
      },
      {
        id: 'quadrillage-3',
        title: { fr: 'Quadrillage III', en: 'Grid III', zh: '网格 III', ja: 'グリッド III', es: 'Cuadrícula III', ro: 'Caroiaj III', ru: 'Решётка III', 
          ar: 'شبكة III'},
        year: '2023',
        technique: 'Peinture sur toile',
        dimensions: '121 x 102 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/t15thm6j_1000014958.jpg'
      },
      {
        id: 'quadrillage-4',
        title: { fr: 'Quadrillage IV', en: 'Grid IV', zh: '网格 IV', ja: 'グリッド IV', es: 'Cuadrícula IV', ro: 'Caroiaj IV', ru: 'Решётка IV', 
          ar: 'شبكة IV'},
        year: '2023',
        technique: 'Peinture sur toile',
        dimensions: '121 x 102 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gfu72nts_1000014957.jpg'
      }
    ]
  },
  eroticism: {
    id: 'eroticism',
    title: 'eroticism',
    images: [
      {
        id: 'erotisme-1',
        title: { fr: 'Érotisme - Œuvre 1', en: 'Eroticism - Work 1', zh: '情色 - 作品 1', ja: 'エロティシズム - 作品 1', es: 'Erotismo - Obra 1', ro: 'Erotism - Lucrare 1', ru: 'Эротизм - Работа 1', 
          ar: 'إيروتيكية - عمل 1'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '147 x 128 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/obo0zh17_1000016137.jpg'
      },
      {
        id: 'erotisme-2',
        title: { fr: 'Érotisme - Œuvre 2', en: 'Eroticism - Work 2', zh: '情色 - 作品 2', ja: 'エロティシズム - 作品 2', es: 'Erotismo - Obra 2', ro: 'Erotism - Lucrare 2', ru: 'Эротизм - Работа 2', 
          ar: 'إيروتيكية - عمل 2'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '100 x 124 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/w4ukvi7h_1000016138.jpg'
      },
      {
        id: 'erotisme-3',
        title: { fr: 'Érotisme - Œuvre 3', en: 'Eroticism - Work 3', zh: '情色 - 作品 3', ja: 'エロティシズム - 作品 3', es: 'Erotismo - Obra 3', ro: 'Erotism - Lucrare 3', ru: 'Эротизм - Работа 3', 
          ar: 'إيروتيكية - عمل 3'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '100 x 124 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/nrb1rxr4_1000016103.jpg'
      },
      {
        id: 'erotisme-4',
        title: { fr: 'Érotisme - Œuvre 4', en: 'Eroticism - Work 4', zh: '情色 - 作品 4', ja: 'エロティシズム - 作品 4', es: 'Erotismo - Obra 4', ro: 'Erotism - Lucrare 4', ru: 'Эротизм - Работа 4', 
          ar: 'إيروتيكية - عمل 4'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '157 x 132 cm (collection privée)',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ud76oh4n_1000016105.jpg'
      },
      {
        id: 'erotisme-5',
        title: { fr: 'Érotisme - Œuvre 5', en: 'Eroticism - Work 5', zh: '情色 - 作品 5', ja: 'エロティシズム - 作品 5', es: 'Erotismo - Obra 5', ro: 'Erotism - Lucrare 5', ru: 'Эротизм - Работа 5', 
          ar: 'إيروتيكية - عمل 5'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '117 x 132 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/9w9i7pbn_1000016222.jpg'
      },
      {
        id: 'erotisme-6',
        title: 'Érotisme - Œuvre 6',
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '138 x 120 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/nonclo0s_1000016224.jpg'
      },
      {
        id: 'erotisme-7',
        title: 'Érotisme - Œuvre 7',
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '138 x 120 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/krsvbbom_1000016225.jpg'
      }
    ]
  },
  universe: {
    id: 'universe',
    title: 'universe',
    images: [
      {
        id: 'univers-1',
        title: {
          fr: 'Cosmos I',
          en: 'Cosmos I',
          zh: '宇宙 I',
          ja: 'コスモス I',
          es: 'Cosmos I',
          ro: 'Cosmos I',
          ru: 'Космос I',
        
          ar: 'كوزموس I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '167 x 139 cm (Manhattan map)',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2vahhpr5_1000014909.jpg'
      },
      {
        id: 'univers-2',
        title: {
          fr: 'Cosmos II',
          en: 'Cosmos II',
          zh: '宇宙 II',
          ja: 'コスモス II',
          es: 'Cosmos II',
          ro: 'Cosmos II',
          ru: 'Космос II',
        
          ar: 'كوزموس II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '147 x 123 cm (collection particulière, œuvre dérobée)',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/df4ry2ov_1000014897.jpg'
      },
      {
        id: 'univers-3',
        title: {
          fr: 'L\'Univers - Œuvre 3',
          en: 'The Universe - Work 3',
          zh: '宇宙 - 作品 3',
          ja: '宇宙 - 作品 3',
          es: 'El Universo - Obra 3',
          ro: 'Universul - Lucrare 3',
          ru: 'Вселенная - Работа 3'
        },
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '72 x 94 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/vl2vsak5_1000016209.jpg'
      },
      {
        id: 'univers-4',
        title: {
          fr: 'L\'Univers - Œuvre 4',
          en: 'The Universe - Work 4',
          zh: '宇宙 - 作品 4',
          ja: '宇宙 - 作品 4',
          es: 'El Universo - Obra 4',
          ro: 'Universul - Lucrare 4',
          ru: 'Вселенная - Работа 4'
        },
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '167 x 132 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/y07xo72j_1000016197.jpg'
      },
      {
        id: 'univers-5',
        title: {
          fr: 'L\'Univers - Œuvre 5',
          en: 'The Universe - Work 5',
          zh: '宇宙 - 作品 5',
          ja: '宇宙 - 作品 5',
          es: 'El Universo - Obra 5',
          ro: 'Universul - Lucrare 5',
          ru: 'Вселенная - Работа 5'
        },
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '146 x 124 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/4wew9de2_1000016196.jpg'
      },
      {
        id: 'univers-6',
        title: {
          fr: 'L\'Univers - Œuvre 6',
          en: 'The Universe - Work 6',
          zh: '宇宙 - 作品 6',
          ja: '宇宙 - 作品 6',
          es: 'El Universo - Obra 6',
          ro: 'Universul - Lucrare 6',
          ru: 'Вселенная - Работа 6'
        },
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '167 x 132 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/dyoqtlcx_1000016198.jpg'
      }
    ]
  },
  pollock: {
    id: 'pollock',
    title: 'pollock',
    images: [
      {
        id: 'pollock-1',
        title: { fr: 'Renaissance I', en: 'Renaissance I', zh: '文艺复兴 I', ja: 'ルネサンス I', es: 'Renacimiento I', ro: 'Renaștere I', ru: 'Возрождение I', 
          ar: 'نهضة I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '117 x 104 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gasudt70_1000014924.jpg'
      },
      {
        id: 'pollock-2',
        title: { fr: 'Renaissance II', en: 'Renaissance II', zh: '文艺复兴 II', ja: 'ルネサンス II', es: 'Renacimiento II', ro: 'Renaștere II', ru: 'Возрождение II', 
          ar: 'نهضة II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '105 x 85 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/r0mrofub_1000014925.jpg'
      },
      {
        id: 'pollock-3',
        title: { fr: 'Renaissance III', en: 'Renaissance III', zh: '文艺复兴 III', ja: 'ルネサンス III', es: 'Renacimiento III', ro: 'Renaștere III', ru: 'Возрождение III', 
          ar: 'نهضة III'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '146 x 127 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/trbwm0o0_1000014922.jpg'
      },
      {
        id: 'pollock-4',
        title: { fr: 'Renaissance IV', en: 'Renaissance IV', zh: '文艺复兴 IV', ja: 'ルネサンス IV', es: 'Renacimiento IV', ro: 'Renaștere IV', ru: 'Возрождение IV', 
          ar: 'نهضة IV'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '127 x 107 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/umgrjier_1000014923.jpg'
      },
      {
        id: 'pollock-5',
        title: { fr: 'Renaissance V', en: 'Renaissance V', zh: '文艺复兴 V', ja: 'ルネサンス V', es: 'Renacimiento V', ro: 'Renaștere V', ru: 'Возрождение V', 
          ar: 'نهضة V'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '154 x 122 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/m0yo21x6_1000014910.jpg'
      }
    ]
  },
  pollockCubism: {
    id: 'pollockCubism',
    title: 'pollockCubism',
    images: [
      {
        id: 'pc-1',
        title: { fr: 'Fusion I', en: 'Fusion I', zh: '融合 I', ja: 'フュージョン I', es: 'Fusión I', ro: 'Fuziune I', ru: 'Слияние I', 
          ar: 'اندماج I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '118 x 92 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5ig0xhlv_1000014936.jpg'
      },
      {
        id: 'pc-2',
        title: { fr: 'Fusion II', en: 'Fusion II', zh: '融合 II', ja: 'フュージョン II', es: 'Fusión II', ro: 'Fuziune II', ru: 'Слияние II', 
          ar: 'اندماج II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '118 x 92 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/9ce79ozt_1000014935.jpg'
      },
      {
        id: 'pc-3',
        title: { fr: 'Fusion III', en: 'Fusion III', zh: '融合 III', ja: 'フュージョン III', es: 'Fusión III', ro: 'Fuziune III', ru: 'Слияние III', 
          ar: 'اندماج III'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '117 x 89 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/qu57r311_1000016330.jpg'
      },
      {
        id: 'pc-4',
        title: { fr: 'Fusion IV', en: 'Fusion IV', zh: '融合 IV', ja: 'フュージョン IV', es: 'Fusión IV', ro: 'Fuziune IV', ru: 'Слияние IV', 
          ar: 'اندماج IV'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '139 x 117 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/aov0nccl_1000016331.jpg'
      }
    ]
  },
  history: {
    id: 'history',
    title: 'history',
    subtitle: '« Parallèle 38 »',
    images: [
      {
        id: 'history-1',
        title: { fr: 'Tunnel Côte à Côte', en: 'Tunnel Side by Side', zh: '并肩隧道', ja: '並んだトンネル', es: 'Túnel lado a lado', ro: 'Tunel alăturat', ru: 'Туннель бок о бок', ar: 'نفق جنباً إلى جنب' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38 - Guerre de Corée',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/b4k5w8wv_1000014908.jpg'
      },
      {
        id: 'history-2',
        title: { fr: 'Mémoires de Guerre II', en: 'War Memories II', zh: '战争回忆 II', ja: '戦争の記憶 II', es: 'Memorias de Guerra II', ro: 'Memorii de război II', ru: 'Военные воспоминания II',
          ar: 'ذكريات الحرب II' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38 - Kim Phuc',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/4bq12osp_1000014906.jpg'
      },
      {
        id: 'history-3',
        title: { fr: 'Mémoires de Guerre III', en: 'War Memories III', zh: '战争回忆 III', ja: '戦争の記憶 III', es: 'Memorias de Guerra III', ro: 'Memorii de război III', ru: 'Военные воспоминания III', 
          ar: 'ذكريات الحرب III'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/o9ijhior_1000014907.jpg'
      },
      {
        id: 'history-5',
        title: { fr: 'Chaos de Guerre I', en: 'Chaos of War I', zh: '战争混沌 I', ja: '戦争のカオス I', es: 'Caos de Guerra I', ro: 'Haosul Războiului I', ru: 'Хаос войны I', ar: 'فوضى الحرب I' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0ad5wu23_1000012413.jpg'
      },
      {
        id: 'history-6',
        title: { fr: 'Chaos de Guerre II', en: 'Chaos of War II', zh: '战争混沌 II', ja: '戦争のカオス II', es: 'Caos de Guerra II', ro: 'Haosul Războiului II', ru: 'Хаос войны II', ar: 'فوضى الحرب II' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ryljbpi6_1000012415.jpg'
      },
      {
        id: 'history-7',
        title: { fr: 'Chaos de Guerre III', en: 'Chaos of War III', zh: '战争混沌 III', ja: '戦争のカオス III', es: 'Caos de Guerra III', ro: 'Haosul Războiului III', ru: 'Хаос войны III', ar: 'فوضى الحرب III' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/rkk6bedn_1000012418.jpg'
      },
      {
        id: 'history-8',
        title: { fr: 'Souffrances', en: 'Sufferings', zh: '苦难', ja: '苦しみ', es: 'Sufrimientos', ro: 'Suferințe', ru: 'Страдания', ar: 'معاناة' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/cuyczjn7_1000012409.jpg'
      },
      {
        id: 'history-9',
        title: { fr: 'Tourments', en: 'Torments', zh: '折磨', ja: '苦悩', es: 'Tormentos', ro: 'Chinuri', ru: 'Мучения', ar: 'عذاب' },
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/o24j5fio_1000012402.jpg'
      },
      {
        id: 'history-10',
        title: { fr: 'Parallèle 38 - Œuvre 1', en: 'Parallel 38 - Work 1', zh: '第38平行线 - 作品 1', ja: '北緯38度線 - 作品 1', es: 'Paralelo 38 - Obra 1', ro: 'Paralela 38 - Lucrare 1', ru: 'Параллель 38 - Работа 1', 
          ar: 'خط 38 - عمل 1'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/cv50rkwc_1000015930.jpg'
      },
      {
        id: 'history-11',
        title: { fr: 'Parallèle 38 - Œuvre 2', en: 'Parallel 38 - Work 2', zh: '第38平行线 - 作品 2', ja: '北緯38度線 - 作品 2', es: 'Paralelo 38 - Obra 2', ro: 'Paralela 38 - Lucrare 2', ru: 'Параллель 38 - Работа 2', 
          ar: 'خط 38 - عمل 2'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/vb3ytb6i_1000015931.jpg'
      },
      {
        id: 'history-12',
        title: { fr: 'Parallèle 38 - Œuvre 3', en: 'Parallel 38 - Work 3', zh: '第38平行线 - 作品 3', ja: '北緯38度線 - 作品 3', es: 'Paralelo 38 - Obra 3', ro: 'Paralela 38 - Lucrare 3', ru: 'Параллель 38 - Работа 3', 
          ar: 'خط 38 - عمل 3'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/dghzicup_1000015932.jpg'
      },
      {
        id: 'history-13',
        title: { fr: 'Parallèle 38 - Œuvre 4', en: 'Parallel 38 - Work 4', zh: '第38平行线 - 作品 4', ja: '北緯38度線 - 作品 4', es: 'Paralelo 38 - Obra 4', ro: 'Paralela 38 - Lucrare 4', ru: 'Параллель 38 - Работа 4', 
          ar: 'خط 38 - عمل 4'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0fk7qvie_1000015933.jpg'
      },
      {
        id: 'history-14',
        title: { fr: 'Parallèle 38 - Œuvre 5', en: 'Parallel 38 - Work 5', zh: '第38平行线 - 作品 5', ja: '北緯38度線 - 作品 5', es: 'Paralelo 38 - Obra 5', ro: 'Paralela 38 - Lucrare 5', ru: 'Параллель 38 - Работа 5', 
          ar: 'خط 38 - عمل 5'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3x23n2qg_1000015934.jpg'
      },
      {
        id: 'history-15',
        title: { fr: 'Parallèle 38 - Œuvre 6', en: 'Parallel 38 - Work 6', zh: '第38平行线 - 作品 6', ja: '北緯38度線 - 作品 6', es: 'Paralelo 38 - Obra 6', ro: 'Paralela 38 - Lucrare 6', ru: 'Параллель 38 - Работа 6', 
          ar: 'خط 38 - عمل 6'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/8qmqg0qv_1000015935.jpg'
      },
      {
        id: 'history-16',
        title: { fr: 'Parallèle 38 - Œuvre 7', en: 'Parallel 38 - Work 7', zh: '第38平行线 - 作品 7', ja: '北緯38度線 - 作品 7', es: 'Paralelo 38 - Obra 7', ro: 'Paralela 38 - Lucrare 7', ru: 'Параллель 38 - Работа 7', 
          ar: 'خط 38 - عمل 7'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/on8h9j6p_1000015936.jpg'
      },
      {
        id: 'history-17',
        title: { fr: 'Parallèle 38 - Œuvre 8', en: 'Parallel 38 - Work 8', zh: '第38平行线 - 作品 8', ja: '北緯38度線 - 作品 8', es: 'Paralelo 38 - Obra 8', ro: 'Paralela 38 - Lucrare 8', ru: 'Параллель 38 - Работа 8', 
          ar: 'خط 38 - عمل 8'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/r1cod7bo_1000015939.jpg'
      },
      {
        id: 'history-18',
        title: { fr: 'Parallèle 38 - Œuvre 9', en: 'Parallel 38 - Work 9', zh: '第38平行线 - 作品 9', ja: '北緯38度線 - 作品 9', es: 'Paralelo 38 - Obra 9', ro: 'Paralela 38 - Lucrare 9', ru: 'Параллель 38 - Работа 9', 
          ar: 'خط 38 - عمل 9'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ypny5xho_1000015938.jpg'
      },
      {
        id: 'history-19',
        title: { fr: 'Parallèle 38 - Œuvre 10', en: 'Parallel 38 - Work 10', zh: '第38平行线 - 作品 10', ja: '北緯38度線 - 作品 10', es: 'Paralelo 38 - Obra 10', ro: 'Paralela 38 - Lucrare 10', ru: 'Параллель 38 - Работа 10', 
          ar: 'خط 38 - عمل 10'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/zjx6bar4_1000015937.jpg'
      },
      {
        id: 'history-20',
        title: { fr: 'Parallèle 38 - Œuvre 11', en: 'Parallel 38 - Work 11', zh: '第38平行线 - 作品 11', ja: '北緯38度線 - 作品 11', es: 'Paralelo 38 - Obra 11', ro: 'Paralela 38 - Lucrare 11', ru: 'Параллель 38 - Работа 11', 
          ar: 'خط 38 - عمل 11'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wbzlpz7g_1000015939.jpg'
      },
      {
        id: 'history-21',
        title: { fr: 'Parallèle 38 - Œuvre 12', en: 'Parallel 38 - Work 12', zh: '第38平行线 - 作品 12', ja: '北緯38度線 - 作品 12', es: 'Paralelo 38 - Obra 12', ro: 'Paralela 38 - Lucrare 12', ru: 'Параллель 38 - Работа 12', 
          ar: 'خط 38 - عمل 12'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/xtfpx6sp_1000015940.jpg'
      },
      {
        id: 'history-22',
        title: { fr: 'Parallèle 38 - Œuvre 13', en: 'Parallel 38 - Work 13', zh: '第38平行线 - 作品 13', ja: '北緯38度線 - 作品 13', es: 'Paralelo 38 - Obra 13', ro: 'Paralela 38 - Lucrare 13', ru: 'Параллель 38 - Работа 13', 
          ar: 'خط 38 - عمل 13'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/shaj31lc_1000015941.jpg'
      },
      {
        id: 'history-23',
        title: { fr: 'Parallèle 38 - Œuvre 14', en: 'Parallel 38 - Work 14', zh: '第38平行线 - 作品 14', ja: '北緯38度線 - 作品 14', es: 'Paralelo 38 - Obra 14', ro: 'Paralela 38 - Lucrare 14', ru: 'Параллель 38 - Работа 14', 
          ar: 'خط 38 - عمل 14'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/u8i3nkln_1000015942.jpg'
      },
      {
        id: 'history-24',
        title: { fr: 'Parallèle 38 - Œuvre 15', en: 'Parallel 38 - Work 15', zh: '第38平行线 - 作品 15', ja: '北緯38度線 - 作品 15', es: 'Paralelo 38 - Obra 15', ro: 'Paralela 38 - Lucrare 15', ru: 'Параллель 38 - Работа 15', 
          ar: 'خط 38 - عمل 15'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/w4w0z916_1000015943.jpg'
      },
      {
        id: 'history-25',
        title: { fr: 'Parallèle 38 - Œuvre 16', en: 'Parallel 38 - Work 16', zh: '第38平行线 - 作品 16', ja: '北緯38度線 - 作品 16', es: 'Paralelo 38 - Obra 16', ro: 'Paralela 38 - Lucrare 16', ru: 'Параллель 38 - Работа 16', 
          ar: 'خط 38 - عمل 16'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/egxda35t_1000015944.jpg'
      },
      {
        id: 'history-26',
        title: { fr: 'Parallèle 38 - Œuvre 17', en: 'Parallel 38 - Work 17', zh: '第38平行线 - 作品 17', ja: '北緯38度線 - 作品 17', es: 'Paralelo 38 - Obra 17', ro: 'Paralela 38 - Lucrare 17', ru: 'Параллель 38 - Работа 17', 
          ar: 'خط 38 - عمل 17'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0716w04z_1000015946.jpg'
      },
      {
        id: 'history-27',
        title: { fr: 'Parallèle 38 - Œuvre 18', en: 'Parallel 38 - Work 18', zh: '第38平行线 - 作品 18', ja: '北緯38度線 - 作品 18', es: 'Paralelo 38 - Obra 18', ro: 'Paralela 38 - Lucrare 18', ru: 'Параллель 38 - Работа 18', 
          ar: 'خط 38 - عمل 18'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/nd0g0j0k_1000015948.jpg'
      },
      {
        id: 'history-28',
        title: { fr: 'Parallèle 38 - Œuvre 19', en: 'Parallel 38 - Work 19', zh: '第38平行线 - 作品 19', ja: '北緯38度線 - 作品 19', es: 'Paralelo 38 - Obra 19', ro: 'Paralela 38 - Lucrare 19', ru: 'Параллель 38 - Работа 19', 
          ar: 'خط 38 - عمل 19'},
        year: '2020-2021',
        technique: 'Peinture sur toile',
        dimensions: '210 x 150 cm',
        description: 'Série PARALLÈLE 38',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/4xl4uuo6_1000015949.jpg'
      }
    ]
  },
  pantheon: {
    id: 'pantheon',
    title: 'pantheon',
    subtitle: 'Résonances et fragments',
    images: [
      {
        id: 'pantheon-1',
        title: { fr: 'Genèse dans Panthéon - Œuvre 1', en: 'Genesis in Pantheon - Work 1', zh: '万神殿中的创世 - 作品 1', ja: 'パンテオンの創世記 - 作品 1', es: 'Génesis en Panteón - Obra 1', ro: 'Geneza în Panteon - Lucrare 1', ru: 'Генезис в Пантеоне - Работа 1', 
          ar: 'نشأة في البانثيون - عمل 1'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '120 x 147 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/a79xhluq_1000016141.jpg'
      },
      {
        id: 'pantheon-2',
        title: { fr: 'Genèse dans Panthéon - Œuvre 2', en: 'Genesis in Pantheon - Work 2', zh: '万神殿中的创世 - 作品 2', ja: 'パンテオンの創世記 - 作品 2', es: 'Génesis en Panteón - Obra 2', ro: 'Geneza în Panteon - Lucrare 2', ru: 'Генезис в Пантеоне - Работа 2', 
          ar: 'نشأة في البانثيون - عمل 2'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '87 x 68 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/wzcq1f7v_1000016142.jpg'
      },
      {
        id: 'pantheon-3',
        title: { fr: 'Genèse dans Panthéon - Œuvre 3', en: 'Genesis in Pantheon - Work 3', zh: '万神殿中的创世 - 作品 3', ja: 'パンテオンの創世記 - 作品 3', es: 'Génesis en Panteón - Obra 3', ro: 'Geneza în Panteon - Lucrare 3', ru: 'Генезис в Пантеоне - Работа 3', 
          ar: 'نشأة في البانثيون - عمل 3'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '147 x 126 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/6rufxvsi_1000016143.jpg'
      },
      {
        id: 'pantheon-4',
        title: { fr: 'Genèse dans Panthéon - Œuvre 4', en: 'Genesis in Pantheon - Work 4', zh: '万神殿中的创世 - 作品 4', ja: 'パンテオンの創世記 - 作品 4', es: 'Génesis en Panteón - Obra 4', ro: 'Geneza în Panteon - Lucrare 4', ru: 'Генезис в Пантеоне - Работа 4', 
          ar: 'نشأة في البانثيون - عمل 4'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '137 x 107 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5pk0btx4_1000016115.jpg'
      },
      {
        id: 'pantheon-5',
        title: { fr: 'Genèse dans Panthéon - Œuvre 5', en: 'Genesis in Pantheon - Work 5', zh: '万神殿中的创世 - 作品 5', ja: 'パンテオンの創世記 - 作品 5', es: 'Génesis en Panteón - Obra 5', ro: 'Geneza în Panteon - Lucrare 5', ru: 'Генезис в Пантеоне - Работа 5', 
          ar: 'نشأة في البانثيون - عمل 5'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '147 x 120 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/pt1ot02i_1000016116.jpg'
      },
      {
        id: 'pantheon-6',
        title: { fr: 'Genèse dans Panthéon - Œuvre 6', en: 'Genesis in Pantheon - Work 6', zh: '万神殿中的创世 - 作品 6', ja: 'パンテオンの創世記 - 作品 6', es: 'Génesis en Panteón - Obra 6', ro: 'Geneza în Panteon - Lucrare 6', ru: 'Генезис в Пантеоне - Работа 6', 
          ar: 'نشأة في البانثيون - عمل 6'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '137 x 121 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/ba0kpahd_1000016117.jpg'
      },
      {
        id: 'pantheon-7',
        title: { fr: 'Genèse dans Panthéon - Œuvre 7', en: 'Genesis in Pantheon - Work 7', zh: '万神殿中的创世 - 作品 7', ja: 'パンテオンの創世記 - 作品 7', es: 'Génesis en Panteón - Obra 7', ro: 'Geneza în Panteon - Lucrare 7', ru: 'Генезис в Пантеоне - Работа 7', 
          ar: 'نشأة في البانثيون - عمل 7'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '119 x 143 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/im6bzxm9_1000016118.jpg'
      },
      {
        id: 'pantheon-8',
        title: { fr: 'Genèse dans Panthéon - Œuvre 8', en: 'Genesis in Pantheon - Work 8', zh: '万神殿中的创世 - 作品 8', ja: 'パンテオンの創世記 - 作品 8', es: 'Génesis en Panteón - Obra 8', ro: 'Geneza în Panteon - Lucrare 8', ru: 'Генезис в Пантеоне - Работа 8', 
          ar: 'نشأة في البانثيون - عمل 8'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '127 x 117 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/v3ivlqot_1000016119.jpg'
      },
      {
        id: 'pantheon-9',
        title: { fr: 'Genèse dans Panthéon - Œuvre 9', en: 'Genesis in Pantheon - Work 9', zh: '万神殿中的创世 - 作品 9', ja: 'パンテオンの創世記 - 作品 9', es: 'Génesis en Panteón - Obra 9', ro: 'Geneza în Panteon - Lucrare 9', ru: 'Генезис в Пантеоне - Работа 9', 
          ar: 'نشأة في البانثيون - عمل 9'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '139 x 125 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/x9zzqai1_1000016120.jpg'
      },
      {
        id: 'pantheon-10',
        title: { fr: 'Genèse dans Panthéon - Œuvre 10', en: 'Genesis in Pantheon - Work 10', zh: '万神殿中的创世 - 作品 10', ja: 'パンテオンの創世記 - 作品 10', es: 'Génesis en Panteón - Obra 10', ro: 'Geneza în Panteon - Lucrare 10', ru: 'Генезис в Пантеоне - Работа 10', 
          ar: 'نشأة في البانثيون - عمل 10'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '120 x 147 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/4aos8and_1000016121.jpg'
      },
      {
        id: 'pantheon-11',
        title: { fr: 'Genèse dans Panthéon - Œuvre 11', en: 'Genesis in Pantheon - Work 11', zh: '万神殿中的创世 - 作品 11', ja: 'パンテオンの創世記 - 作品 11', es: 'Génesis en Panteón - Obra 11', ro: 'Geneza în Panteon - Lucrare 11', ru: 'Генезис в Пантеоне - Работа 11', 
          ar: 'نشأة في البانثيون - عمل 11'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '120 x 147 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/e8c5pude_1000016124.jpg'
      },
      {
        id: 'pantheon-12',
        title: { fr: 'Genèse dans Panthéon - Œuvre 12', en: 'Genesis in Pantheon - Work 12', zh: '万神殿中的创世 - 作品 12', ja: 'パンテオンの創世記 - 作品 12', es: 'Génesis en Panteón - Obra 12', ro: 'Geneza în Panteon - Lucrare 12', ru: 'Генезис в Пантеоне - Работа 12', 
          ar: 'نشأة في البانثيون - عمل 12'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '120 x 147 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/j99wjuk6_1000016125.jpg'
      },
      {
        id: 'pantheon-13',
        title: { fr: 'Genèse dans Panthéon - Œuvre 13', en: 'Genesis in Pantheon - Work 13', zh: '万神殿中的创世 - 作品 13', ja: 'パンテオンの創世記 - 作品 13', es: 'Génesis en Panteón - Obra 13', ro: 'Geneza în Panteon - Lucrare 13', ru: 'Генезис в Пантеоне - Работа 13', 
          ar: 'نشأة في البانثيون - عمل 13'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '120 x 147 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/po2zzqyh_1000016126.jpg'
      },
      {
        id: 'pantheon-14',
        title: { fr: 'Genèse dans Panthéon - Œuvre 14', en: 'Genesis in Pantheon - Work 14', zh: '万神殿中的创世 - 作品 14', ja: 'パンテオンの創世記 - 作品 14', es: 'Génesis en Panteón - Obra 14', ro: 'Geneza în Panteon - Lucrare 14', ru: 'Генезис в Пантеоне - Работа 14', 
          ar: 'نشأة في البانثيون - عمل 14'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '139 x 118 cm',
        description: 'Série Résonances et fragments',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/c6jhy0ip_1000016127.jpg'
      }
    ]
  },
  sacred: {
    id: 'sacred',
    title: 'sacred',
    subtitle: 'Chronique d\'une création',
    images: [
      {
        id: 'sacred-1',
        title: { fr: 'Émergence du Sacré - Œuvre 1', en: 'Emergence of the Sacred - Work 1', zh: '神圣的涌现 - 作品 1', ja: '聖なるものの出現 - 作品 1', es: 'Emergencia de lo Sagrado - Obra 1', ro: 'Emergența Sacrului - Lucrare 1', ru: 'Возникновение священного - Работа 1', 
          ar: 'ظهور المقدس - عمل 1'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '101 x 94 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/boish9ia_1000016128.jpg'
      },
      {
        id: 'sacred-2',
        title: { fr: 'Émergence du Sacré - Œuvre 2', en: 'Emergence of the Sacred - Work 2', zh: '神圣的涌现 - 作品 2', ja: '聖なるものの出現 - 作品 2', es: 'Emergencia de lo Sagrado - Obra 2', ro: 'Emergența Sacrului - Lucrare 2', ru: 'Возникновение священного - Работа 2', 
          ar: 'ظهور المقدس - عمل 2'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '101 x 94 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/lbyy92zs_1000016129.jpg'
      },
      {
        id: 'sacred-4',
        title: { fr: 'Émergence du Sacré - Œuvre 4', en: 'Emergence of the Sacred - Work 4', zh: '神圣的涌现 - 作品 4', ja: '聖なるものの出現 - 作品 4', es: 'Emergencia de lo Sagrado - Obra 4', ro: 'Emergența Sacrului - Lucrare 4', ru: 'Возникновение священного - Работа 4', 
          ar: 'ظهور المقدس - عمل 4'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/p5a0zf4o_1000016131.jpg'
      },
      {
        id: 'sacred-5',
        title: { fr: 'Émergence du Sacré - Œuvre 5', en: 'Emergence of the Sacred - Work 5', zh: '神圣的涌现 - 作品 5', ja: '聖なるものの出現 - 作品 5', es: 'Emergencia de lo Sagrado - Obra 5', ro: 'Emergența Sacrului - Lucrare 5', ru: 'Возникновение священного - Работа 5', 
          ar: 'ظهور المقدس - عمل 5'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gjnx5x4c_1000016132.jpg'
      },
      {
        id: 'sacred-6',
        title: { fr: 'Émergence du Sacré - Œuvre 6', en: 'Emergence of the Sacred - Work 6', zh: '神圣的涌现 - 作品 6', ja: '聖なるものの出現 - 作品 6', es: 'Emergencia de lo Sagrado - Obra 6', ro: 'Emergența Sacrului - Lucrare 6', ru: 'Возникновение священного - Работа 6', 
          ar: 'ظهور المقدس - عمل 6'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/gfm2vb6m_1000016133.jpg'
      },
      {
        id: 'sacred-7',
        title: { fr: 'Émergence du Sacré - Œuvre 7', en: 'Emergence of the Sacred - Work 7', zh: '神圣的涌现 - 作品 7', ja: '聖なるものの出現 - 作品 7', es: 'Emergencia de lo Sagrado - Obra 7', ro: 'Emergența Sacrului - Lucrare 7', ru: 'Возникновение священного - Работа 7', 
          ar: 'ظهور المقدس - عمل 7'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/hkm9jiqr_1000016134.jpg'
      },
      {
        id: 'sacred-8',
        title: { fr: 'Émergence du Sacré - Œuvre 8', en: 'Emergence of the Sacred - Work 8', zh: '神圣的涌现 - 作品 8', ja: '聖なるものの出現 - 作品 8', es: 'Emergencia de lo Sagrado - Obra 8', ro: 'Emergența Sacrului - Lucrare 8', ru: 'Возникновение священного - Работа 8', 
          ar: 'ظهور المقدس - عمل 8'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '149 x 107 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/a03hmo6x_1000016135.jpg'
      },
      {
        id: 'sacred-9',
        title: { fr: 'Émergence du Sacré - Œuvre 9', en: 'Emergence of the Sacred - Work 9', zh: '神圣的涌现 - 作品 9', ja: '聖なるものの出現 - 作品 9', es: 'Emergencia de lo Sagrado - Obra 9', ro: 'Emergența Sacrului - Lucrare 9', ru: 'Возникновение священного - Работа 9', 
          ar: 'ظهور المقدس - عمل 9'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '107 x 124 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/2ublvjwp_1000016328.jpg'
      },
      {
        id: 'sacred-10',
        title: { fr: 'Émergence du Sacré - Œuvre 10', en: 'Emergence of the Sacred - Work 10', zh: '神圣的涌现 - 作品 10', ja: '聖なるものの出現 - 作品 10', es: 'Emergencia de lo Sagrado - Obra 10', ro: 'Emergența Sacrului - Lucrare 10', ru: 'Возникновение священного - Работа 10', 
          ar: 'ظهور المقدس - عمل 10'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '107 x 124 cm',
        description: 'Série Chronique d\'une création',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/5er7hs6a_1000016329.jpg'
      }
    ]
  },
  lines: {
    id: 'lines',
    title: 'lines',
    images: [
      {
        id: 'lignes-1',
        title: { fr: 'Entre les Lignes I', en: 'Between the Lines I', zh: '字里行间 I', ja: '行間 I', es: 'Entre Líneas I', ro: 'Între rânduri I', ru: 'Между строк I', 
          ar: 'بين السطور I'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '126 x 78 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/dvphzssg_1000014934.jpg'
      },
      {
        id: 'lignes-2',
        title: { fr: 'Entre les Lignes II', en: 'Between the Lines II', zh: '字里行间 II', ja: '行間 II', es: 'Entre Líneas II', ro: 'Între rânduri II', ru: 'Между строк II', 
          ar: 'بين السطور II'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '126 x 78 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/a5aj3akt_1000014933.jpg'
      },
      {
        id: 'lignes-3',
        title: { fr: 'Entre les Lignes III', en: 'Between the Lines III', zh: '字里行间 III', ja: '行間 III', es: 'Entre Líneas III', ro: 'Între rânduri III', ru: 'Между строк III', 
          ar: 'بين السطور III'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '145 x 117 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/xhyeasky_1000014937.jpg'
      },
      {
        id: 'lignes-4',
        title: { fr: 'Entre les Lignes IV', en: 'Between the Lines IV', zh: '字里行间 IV', ja: '行間 IV', es: 'Entre Líneas IV', ro: 'Între rânduri IV', ru: 'Между строк IV', 
          ar: 'بين السطور IV'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '162 x 132 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/er25d2dc_1000014938.jpg'
      },
      {
        id: 'lignes-5',
        title: { fr: 'Entre les Lignes V', en: 'Between the Lines V', zh: '字里行间 V', ja: '行間 V', es: 'Entre Líneas V', ro: 'Între rânduri V', ru: 'Между строк V', 
          ar: 'بين السطور V'},
        year: '2024',
        technique: 'Peinture sur toile',
        dimensions: '126 x 79 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/yz5p1jj7_1000014939.jpg'
      },
      {
        id: 'lignes-6',
        title: { fr: 'Entre les Lignes VI', en: 'Between the Lines VI', zh: '字里行间 VI', ja: '行間 VI', es: 'Entre Líneas VI', ro: 'Între rânduri VI', ru: 'Между строк VI', 
          ar: 'بين السطور VI'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '126 x 79 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/tvs1n2ow_1000016206.jpg'
      },
      {
        id: 'lignes-7',
        title: { fr: 'Entre les Lignes VII', en: 'Between the Lines VII', zh: '字里行间 VII', ja: '行間 VII', es: 'Entre Líneas VII', ro: 'Între rânduri VII', ru: 'Между строк VII', 
          ar: 'بين السطور VII'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '157 x 127 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/0mm55fnu_1000016212.jpg'
      },
      {
        id: 'lignes-8',
        title: { fr: 'Entre les Lignes VIII', en: 'Between the Lines VIII', zh: '字里行间 VIII', ja: '行間 VIII', es: 'Entre Líneas VIII', ro: 'Între rânduri VIII', ru: 'Между строк VIII', 
          ar: 'بين السطور VIII'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '143 x 118 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/c3aqc9i4_1000016213.jpg'
      },
      {
        id: 'lignes-9',
        title: { fr: 'Entre les Lignes IX', en: 'Between the Lines IX', zh: '字里行间 IX', ja: '行間 IX', es: 'Entre Líneas IX', ro: 'Între rânduri IX', ru: 'Между строк IX', 
          ar: 'بين السطور IX'},
        year: '2024-2025',
        technique: 'Peinture sur toile',
        dimensions: '127 x 87 cm',
        image: 'https://customer-assets.emergentagent.com/job_artist-site-maker/artifacts/3jph5788_1000016201.jpg'
      }
    ]
  }
};

export const pressArticles = [
  {
    id: 1,
    title: "Salon d'Automne 2022",
    subtitle: "« Agitation »",
    source: "Salon d'Automne, Paris",
    date: "2022",
    technique: "Huile et acrylique sur toile",
    dimensions: "76 x 120 cm",
    image: PRESS_IMAGES.agitation,
    type: "exhibition"
  },
  {
    id: 2,
    title: "Salon d'Automne 2022",
    subtitle: "« Simone Veil, un autre regard »",
    source: "Salon d'Automne, Paris",
    date: "2022",
    technique: "Peinture sur toile",
    dimensions: "122 x 114 cm",
    image: PRESS_IMAGES.simoneVeil,
    type: "exhibition"
  },
  {
    id: 3,
    title: "Remise du Prix A",
    subtitle: "Par l'Ambassadeur Dinh Toan Thang",
    source: "Galerie Étienne de Causans, Paris",
    date: "2025",
    description: "L'ambassadeur du Vietnam remet le certificat du Prix A à l'artiste Georg Esco",
    image: PRESS_IMAGES.remisePrixA,
    type: "award"
  },
  {
    id: 4,
    title: "Galerie Étienne de Causans",
    subtitle: "Exposition personnelle",
    source: "Paris",
    date: "2025",
    description: "Le tableau « Sur les traces d'Hô Chi Minh » - Pont culturel entre le Vietnam et la France",
    image: PRESS_IMAGES.galerieVisite,
    type: "exhibition"
  },
  {
    id: 5,
    title: "Prix A - Vietnam",
    subtitle: "Certificat officiel",
    source: "République Socialiste du Vietnam",
    date: "2025",
    description: "Plus haute distinction artistique nationale pour « Sur les traces de Hô Chi Minh »",
    image: PRESS_IMAGES.certificatPrixA,
    type: "award",
    darkBackground: true
  },
  {
    id: 6,
    title: "Hôtel Drouot",
    subtitle: "« Émergence »",
    source: "Drouot, Paris",
    date: "2020",
    technique: "Sculpture totem en verre",
    description: "Grande sculpture formée de plaques de verre assemblées, taillées et sablées",
    image: PRESS_IMAGES.emergence,
    type: "auction",
    darkBackground: true
  }
];

export const artistInfo = {
  name: "Georg Esco",
  realName: "Ionita-Radu Georgescu",
  birthDate: "11 mars 1977",
  birthPlace: "Brașov, Transylvanie, Roumanie",
  residence: "Paris, France",
  email: "contact@georg-esco.com",
  phone: "+33 6 86 72 67 34",
  instagram: "@georg_esco11",
  tiktok: "@georg.esco",
  instagramUrl: "https://instagram.com/georg_esco11",
  tiktokUrl: "https://tiktok.com/@georg.esco"
};
